import React from "react";
import Character1Mail from "./Character1Mail.js"
import Character2Mail from "./Character2Mail.js"
import Character3Mail from "./Character3Mail.js"
import Character4Mail from "./Character4Mail.js"

class CharacterMail extends React.Component {
  state = { svg: null };

  componentDidMount() {
    const svgSupport =
      !!document.createElementNS &&
      !!document.createElementNS("http://www.w3.org/2000/svg", "svg")
        .createSVGRect;
    if (svgSupport) {
      this.setState({
        svg: "svg"
      });
    } else {
      this.setState({
        svg: "png"
      });
    }
    console.log(this.props.characterReference);
  }
  render() {
    return (
      <div
        className={
          "option character-illustration-wrapper character-mail " +
          this.state.svg
        }
      >
        {this.props.characterReference === "character-1" && <Character1Mail/>}
        {this.props.characterReference === "character-2" && <Character2Mail/>}
        {this.props.characterReference === "character-3" && <Character3Mail/>}
        {this.props.characterReference === "character-4" && <Character4Mail/>}
        <svg className={"character-background character-mail-background"} />
      </div>
    );
  }
}

export default CharacterMail;
